import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { environment } from "../environment";
import { apiS, apiS_withoutToken } from "./api-base"
import { getESGReqHeader, getReqHeader, queryItemReqBody } from "./tool-service";

//取得版本資訊 不須token
export const getCodeVersion = async () => {
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("version")}`, method: 'get' },false,true)
}

//dpItem
export const getSubItemsByItemNo = async (itemNo, orderNo) => {
    let reqBody = queryItemReqBody(itemNo, orderNo);
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0000102")}`, method: 'post', data: ReqBody })
}

export const updateUserLoginRecord = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0020104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0020104")}`, method: 'post', data: ReqBody })
}

export const initDataProp = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000001'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0000001")}`, method: 'post',data:ReqBody})
}



//取得使用者資訊 AA0003
export const getLoginUserInfo = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getReqHeader('AA0003'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${environment.contextPath}/${environment.basicModule}/AA0003`, method: 'post', data: ReqBody })
}

export const updateTUserData = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getReqHeader('AA0006'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${environment.contextPath}/${environment.basicModule}/AA0006`, method: 'post', data: ReqBody })
}

export const queryFuncByLoginUser = async () => {
    let ReqBody = {
        ReqHeader: getReqHeader('AA0012'),
        ReqBody: {}
    }
    return await apiS({ url: `/${environment.contextPath}${environment.basicModule}/AA0012`, method: 'post', data: ReqBody })
}

export const setFuncList = async () => {
    let ReqBody = {
        ReqHeader: getReqHeader('AA0101'),
        ReqBody: {}
    }
    return await apiS({ url: `/${environment.contextPath}${environment.basicModule}/AA0101`, method: 'post', data: ReqBody })
}

export const queryUserDataByLoginUser = async () => {
    let ReqBody = {
        ReqHeader: getReqHeader('AA0002'),
        ReqBody: {}
    }
    return await apiS({ url: `/${environment.contextPath}${environment.basicModule}/AA0002`, method: 'post', data: ReqBody })
}




